import {AppName} from './types';

export const SOURCE_FILE = 'main.json';

export const BLOCKLY_LABS: AppName[] = [
  'calc',
  'dance',
  'eval',
  'flappy',
  'music',
  'thebadguys',
  'turtle',
  'craft',
  'studio',
  'bounce',
  'poetry',
  'spritelab',
];
